import { call, put, takeLatest, select } from "@redux-saga/core/effects";
import { jarvisPrimeOnboardingApis } from "./jarvisPrimeOnboardingApis";
import { jarvisPrimeOnboardingParser } from "./jarvisPrimeOnboardingParser";
import { jarvisPrimeOnboardingConstants } from "./jarvisPrimeOnboardingConstants";
import { jarvisPrimeOnboardingActions } from "./jarvisPrimeOnboardingActions";
import { mergeKycWithLoginProfile } from "helper/ckycPrefill";

function* getOnboardingDataSaga() {
  try {
    yield put({
      type: jarvisPrimeOnboardingConstants.PRIME_ONBOARDING_DATA_REQUEST,
    });

    const res = yield call(jarvisPrimeOnboardingApis.getOnboardingData);

    const payload = jarvisPrimeOnboardingParser.primeOnboardingData(res);
    const loginProfile = yield select((state) => state.customer.loginProfile);

    yield put({
      type: jarvisPrimeOnboardingConstants.PRIME_ONBOARDING_DATA_RESPONSE,
      payload,
    });

    const kyc = mergeKycWithLoginProfile(payload, loginProfile);

    yield put(
      jarvisPrimeOnboardingActions.updatePrimeOnboardingData({
        panNumber: kyc.panNumber,
        dateOfBirth: kyc.dateOfBirth,
        aadharNumber: kyc.aadharNumber,
      }),
    );
  } catch (e) {
    yield put({
      type: jarvisPrimeOnboardingConstants.PRIME_ONBOARDING_DATA_RESPONSE,
      payload: {},
    });
  }
}

function* getPrimePortfolioDataSaga() {
  try {
    yield put({
      type: jarvisPrimeOnboardingConstants.PRIME_PORTFOLIO_DATA_REQUEST,
    });

    const res = yield call(jarvisPrimeOnboardingApis.getPortfolioData);
    const payload = jarvisPrimeOnboardingParser.portfolioData(res);

    yield put({
      type: jarvisPrimeOnboardingConstants.PRIME_PORTFOLIO_DATA_RESPONSE,
      payload,
    });
  } catch (e) {
    yield put({
      type: jarvisPrimeOnboardingConstants.PRIME_PORTFOLIO_DATA_RESPONSE,
      payload: {},
    });
  }
}

function* getPricingDataSaga() {
  try {
    yield put({ type: jarvisPrimeOnboardingConstants.PRICING_DATA_REQUEST });

    const res = yield call(jarvisPrimeOnboardingApis.getPricingData);
    const payload = jarvisPrimeOnboardingParser.pricingData(res);
    yield put({
      type: jarvisPrimeOnboardingConstants.PRICING_DATA_RESPONSE,
      payload,
    });
  } catch (error) {
    yield put({
      type: jarvisPrimeOnboardingConstants.PRICING_DATA_RESPONSE,
      payload: {},
    });
  }
}

export function* registerJarvisPrimeOnboardingSagas() {
  yield takeLatest(
    jarvisPrimeOnboardingConstants.PRIME_ONBOARDING_DATA_SAGA,
    getOnboardingDataSaga,
  );

  yield takeLatest(
    jarvisPrimeOnboardingConstants.PRIME_PORTFOLIO_DATA_SAGA,
    getPrimePortfolioDataSaga,
  );

  yield takeLatest(
    jarvisPrimeOnboardingConstants.PRICING_DATA_SAGA,
    getPricingDataSaga,
  );
}
